import React from 'react';
import Layout from './components/layout/Layout';
import MainContent from './components/MainContent';
import './styles/background.css';

function App() {
  return (
    <Layout>
      <MainContent />
    </Layout>
  );
}

export default App;